import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import axios from 'axios';
import { setKmfApiDetails } from '../../../actions/kaMetlhaFuneralCover/referenceData';
import { API_CALL_STATUS } from '../../../reducers/status';
import { getBankingDetailsSummary } from '../../../selectors/kaMetlhaFuneralCover/bankingDetails';
import { getPersonalDetailsSummary, getPurchasePersonalDetailsForm } from '../../../selectors/kaMetlhaFuneralCover/personalDetails';
import { getBenefitDetailsSummary, getBenificiaryDetailsSummary, getFinalQuotation, getLivesCoveredSummaryPayload } from '../../../selectors/kaMetlhaFuneralCover/quote';
import { getDocumentsArray, getUploadDocumentsSummary } from '../../../selectors/kaMetlhaFuneralCover/uploadDocuments';
import { getQuoteResponse } from '../../../selectors/kaMetlhaFuneralCover/referenceData';

export const purchaseMailService = (store, next, action) => {
    const state=store.getState();
    (async () => {
        try{
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.PENDING,name:'purchaseMailService'}));
            const submittedDocs=getUploadDocumentsSummary(state)
            const {firstName,middleName,surname,mobileNumber,email}= getPurchasePersonalDetailsForm(state)
            const productLabel='Ka-Metlha-Funeral'
            const monthlyQuoteAllproducts = getFinalQuotation(state)
            const referenceNumber=action?.value
            const {funeralPremium}=getQuoteResponse(state)
            const premiumFrequency = 'Monthly'
        const {personalDetails,contactDetails,addressDetails}=getPersonalDetailsSummary(state) 
        const benifitsDetails=getBenefitDetailsSummary(state) 
        const benificiaryDetails=getBenificiaryDetailsSummary(state) 
        const bankingDetails=getBankingDetailsSummary(state) 
        const uploadDocuments=getUploadDocumentsSummary(state) 
        const livesCoveredDetails=getLivesCoveredSummaryPayload(state)
         const documentsArray = getDocumentsArray(state);
        const purchaseSummary = [
            { title: 'Personal Details', data: personalDetails },
            { title: 'Address Details', data: addressDetails },
            { title: 'Contact Details (Main Member)', data: contactDetails },
            ...(benifitsDetails?.length > 0 ? [{ title: 'Benefit Details', data: benifitsDetails }] : []),
            {title: 'Beneficiary Details',data:benificiaryDetails},
            {title: 'Payment Details',data:bankingDetails},
            {title: 'Documents',data:uploadDocuments},
            ...livesCoveredDetails
        ];
        const userDataFields = [...purchaseSummary]

        const sampleRequestBody = {
            firstName:firstName?.value,
            lastName:surname?.value,
            contactNumber:mobileNumber?.value,
            subject:`Web: ${productLabel} : ${firstName?.value+' '+surname?.value} - REF: ${referenceNumber?.id}`,
            userDataFields,
            templateType:"ALLSURE_QUOTE_CUSTOMER",
            monthlyPremium: `${funeralPremium ? (+funeralPremium?.toFixed(2)) : ''}`,
            yearlyPremium:null,
            email:"BW_KMF_BUSSINESS_MAIL",
        }
         const formData = new FormData(); 
         Object.values(documentsArray)?.map((doc)=>{
         doc?.file &&  formData.append('files', doc.file);
         })
         formData.append('data', JSON.stringify(sampleRequestBody))
        const response = await sendEmailNotification(formData);
        if (response && response.status === httpStatusCode.OK) {
            store.dispatch(setKmfApiDetails(API_CALL_STATUS.SUCCESS));
        } else {
            store.dispatch(setKmfApiDetails(API_CALL_STATUS.FAILURE));
        }
    }
        catch(error){
            console.log(error)
            store.dispatch(setKmfApiDetails(API_CALL_STATUS.FAILURE));
        }
    })();
    return next(action);
};

export const sendEmailNotification = async (requestBody) => {
    try {
        const response = await axios({
            url: 'om-api/submit-notification/submitNotificationEmail/withAttachments',
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data',
                // Accept: 'application/json',
            },
            data: requestBody,
        });
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};